module.exports = __webpack_public_path__ + "img/bg_welcome.2c7326d0.png";